'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Creating a healthy home environment
 * This gets shown when user clicks on the link
 * on App1 of Module2
 */
var HealthyHome = function (_Component) {
  (0, _inherits3.default)(HealthyHome, _Component);

  function HealthyHome() {
    (0, _classCallCheck3.default)(this, HealthyHome);
    return (0, _possibleConstructorReturn3.default)(this, (HealthyHome.__proto__ || (0, _getPrototypeOf2.default)(HealthyHome)).apply(this, arguments));
  }

  (0, _createClass3.default)(HealthyHome, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h4',
          null,
          'Do you keep fruits and vegetables visible and ready to eat?'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              'After you go grocery shopping, try to get into the habit of washing and chopping up some of the vegies before you put them away. We are more likely to eat a healthy snack if it is ready to eat when we are hungry.'
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              'If your child does not eat enough fruit, one of the easiest things you can do is wash some fresh fruit, and keep it out on the table.'
            )
          )
        ),
        _react2.default.createElement(
          'h4',
          null,
          'Do you include fruit and vegetables in lunches and snacks?'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Try to provide fruit and vegies at lunch and as snacks. You can put them on a sandwich, chop them up, serve them whole, skewer them, bake them, stew them and so much more.'
        ),
        _react2.default.createElement(
          'h4',
          null,
          'Do you buy enough fruit and vegetables?'
        ),
        _react2.default.createElement(
          'p',
          null,
          'We know it is important to buy fruit and vegies, so why don\u2019t we always do it? Sometimes it can be difficult because they can seem too expensive or heavy to transport, because there is too much wastage from uneaten vegies, or because it can be a pain to take kids shopping.'
        ),
        _react2.default.createElement(
          'h4',
          null,
          'Do you include vegetables with dinner?'
        ),
        _react2.default.createElement(
          'p',
          null,
          'It is important to include a few serves of vegies with your family meal. You might like to have a look through the recipes in the resources section, for simple recipes that are low-cost and full of vegies for ideas you might like to try for your family.'
        ),
        _react2.default.createElement(
          'h4',
          null,
          'Do you limit non-core or less healthy foods in the home?'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Most of us have at least some unhealthy food in our home. When kids know that there are non-core foods in the house, it can be difficult to encourage them to eat healthy foods.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'To help avoid this problem, try to:'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              'Buy them when children are not with you'
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              'Unpack them when your children are not watching'
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              'Store them somewhere your children won\'t be able to find them'
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              'Keep them out of your child\'s sight'
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              'Keep them out of your child\'s reach'
            )
          )
        )
      );
    }
  }]);
  return HealthyHome;
}(_react.Component);

exports.default = HealthyHome;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/2/Components/HealthyHome.js
// module id = 1190
// module chunks = 0